import './header.scss';

import angular from 'angular';

import commonModule from '../../common';
import portalShellModule from 'portal/shell';

import shopHeaderComponent from './shopHeader.component';
import shopMobileHeader from './mobileHeader.component';

export default angular.module('fp:customerportal:shop:shell:header', [
    commonModule.name,
    portalShellModule.name
])
.component('fpShopHeader', shopHeaderComponent)
.component('fpShopMobileHeader', shopMobileHeader);